import { WallSide } from '../enums/wallSide.enum';
import { FinishTypes } from '../enums/finishTypes.enum';

export class WallFinish {
  side: WallSide;
  interior: FinishTypes;
  exterior: FinishTypes;

  constructor(side: WallSide, exterior?: FinishTypes, interior?: FinishTypes) {
    this.side = side;
    this.interior = interior !== undefined ? interior : FinishTypes.STEEL;
    this.exterior = exterior !== undefined ? exterior : FinishTypes.STEEL;
  }
}
